import React from "react";
import "./Keynotes.css";

export const Keynotes = () => {
  return (
    <div className="keynote-layout">
      <div className="keynote-text-layout">
        <h2>Keynotes</h2>
        <h3>Keynote 1:</h3>
        <h3>
          Professor Vinny Cahill, Professor of Computer Science, Trinity College
          Dublin
        </h3>
        <h4>Title of Talk TBC</h4>
        <br />
        <h4>Abstract</h4>
        <p>TBC</p>
        <div className="keynote-biography-layout">
          <img
            className="keynote-img"
            src={"./images/profiles/vinny-cahill.jpg"}
          />
          <div className="keynote-text">
            <p>
              Prof Vinny Cahill holds a Personal Chair in Computer Science at
              Trinity College Dublin. Prof Cahill has previously served as the
              University's Dean & Vice-President for Research, Dean of the
              Faculty of Engineering, Mathematics and Science - one of the
              University's three faculties, and in a number of other roles.
              Prof. Cahill's research addresses many aspects of distributed
              systems, in particular, middleware and programming models for
              mobile, ubiquitous and autonomic computing with application to
              optimization of urban resource usage and service delivery in order
              to improve the quality of life and sustainability of cities.
            </p>
          </div>
        </div>
        <br />
        <hr />
        <h3>Keynote 2:</h3>
        <h3>
          {" "}
          Professor Akane Sano, Associate Professor, Electrical and Computer
          Engineering, Rice University
        </h3>
        <h4>Title of Talk TBC</h4>
        <br />
        <h4>Abstract</h4>
        <p>TBC</p>
        <div className="keynote-biography-layout">
          <img
            className="keynote-img"
            src={"./images/profiles/Akane_Sano.webp"}
          />
          <div className="keynote-text">
            <p>
              Akane Sano is an Assistant Professor at Rice University,
              Department of Electrical Computer Engineering, Computer Science,
              and Bioengineering. She directs the Computational Wellbeing Group
              and is a member of Scalable Health Labs.
            </p>
            <p>
              Her research includes data science, machine learning, and
              human-centered intelligent systems for health and wellbeing and
              spans in the field of affective computing, ubiquitous and wearable
              computing, and biobehavioral sensing and analysis/modeling. Her
              research targets (1) the analysis and modeling of human ambulatory
              multimodal time series data including physiological, biological
              and behavioral data and surveys for measuring, predicting,
              improving, and understanding human physiology and behavior and
              human factors such as health, wellbeing, and performance and (2)
              development of human-centered computing technologies for health,
              wellbeing, and performance. She has been working on developing
              tools, algorithms, and systems to measure, forecast, understand
              and improve health and wellbeing using multimodal data from mobile
              and wearable sensors, devices in daily life settings, and clinical
              assessment especially for measuring, predicting, and
              intervening/improving clinical outcomes, stress, mental health,
              sleep, and performance.{" "}
            </p>
            <p>
              She obtained her PhD at MIT Media Lab, and her MEng and BEng at
              Keio University, Japan. Before she joined Rice University, she was
              a Research Scientist in Affective Computing Group at MIT Media
              Lab, and a visiting scientist/lecturer at People-Aware Computing
              Lab, Cornell University. Before she came to the US, she was a
              researcher/engineer at Sony Corporation focusing on wearable
              computing, intelligent systems, and human/computer interaction.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
